import { useSelector } from 'react-redux';
import { isCpcSupplierCardOnPage } from '../../Helpers/supplierCard';

/**
 * Hook to check if forward navigation is blocked by a supplier card.
 * This is abstracted to a hook to limit the state required for the parent component.
 */
const useIsForwardNavigationBlockedBySupplierCard = () => {
  const { currentPage } = useSelector((store) => store.navigation);
  const components = useSelector((store) => store.components);
  const { phoneNumberCountryCode, subcategoryId } = useSelector(
    (store) => store.formConfig
  );
  const { dynamicNewsletterName } = useSelector((store) => store.newsletter);

  const isForwardNavigationBlockedBySupplierCard = isCpcSupplierCardOnPage({
    currentPage,
    components,
    dynamicNewsletterName,
    phoneNumberCountryCode,
    subcategoryId,
  });

  return { isForwardNavigationBlockedBySupplierCard };
};

export default useIsForwardNavigationBlockedBySupplierCard;
